var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 91,
    viewBox: "0 0 250 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0079 87.8525L35.8264 88.2755V45.6153L34.4435 47.0148V68.1693V90.3755H47.6327L45.0079 87.8525Z",
    fill: "#CAA965"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6761 43.739L34.4435 47.0079L30.5764 42.8419L37.6761 43.739Z",
    fill: "#F79979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8768 45.4865L8.93595 41.6007L29.7709 43.9702L30.6829 42.9698L6.64097 40.1661L5.87012 42.3545L30.7122 46.7229L29.203 58.0439L32.0569 55.7143L32.6711 47.5263L30.8768 45.4865Z",
    fill: "#CAA965"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36776 34.0706L0 39.3425L15.6728 37.6953L5.36776 34.0706Z",
    fill: "#F79979"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2221 36.202L11.1974 27.2629L5.36774 34.0706L22.2221 36.202Z",
    fill: "#F57859"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2989 36.202L15.6728 37.6953L5.36774 34.0707L22.2989 36.202Z",
    fill: "#F04338"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2932 27.2629L37.5621 17.5534L39.3179 25.8149L49.2932 27.2629Z",
    fill: "#F79979"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3179 25.8149L37.5621 17.5534L24.4309 16.1747L39.3179 25.8149Z",
    fill: "#F57859"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6648 36.8679L29.7896 24.4362L49.2932 27.2629L46.6648 36.8679Z",
    fill: "#F57859"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8401 30.8971L29.1114 36.3992L22.2221 36.202L23.8401 30.8971Z",
    fill: "#F79979"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7896 24.4362L23.8401 30.8972L11.1974 27.263L29.7896 24.4362Z",
    fill: "#F04338"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6647 36.8679L37.562 43.7641L22.2221 36.2019L46.6647 36.8679Z",
    fill: "#F04338"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3179 25.8149L24.4309 16.1747L14.0751 22.3006L39.3179 25.8149Z",
    fill: "#EE3124"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.562 43.7641L19.7055 41.6961L22.2221 36.2019L37.562 43.7641Z",
    fill: "#EE3124"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8401 30.8972L29.7896 24.4362L46.6647 36.8679L23.8401 30.8972Z",
    fill: "#EE3124"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8401 30.8971L22.2221 36.202L11.1974 27.2629L23.8401 30.8971Z",
    fill: "#EE3124"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6647 36.8679L29.1114 36.3992L23.8401 30.8972L46.6647 36.8679Z",
    fill: "#F57859"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6648 36.8679L37.5621 43.7642L45.2573 42.0125L46.6648 36.8679Z",
    fill: "#C52C23"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7896 24.4362L11.1974 27.2629L14.0752 22.3006L29.7896 24.4362Z",
    fill: "#C52C23"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2221 36.202L19.7056 41.6961L15.6729 37.6953L22.2221 36.202Z",
    fill: "#C52C23"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7048 21.9985L55.3146 33.9592L59.0022 21.6544L52.7048 21.9985Z",
    fill: "#F79979"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5457 5.70972L54.6727 0.904573L61.6781 -2.19345e-05L56.5457 5.70972Z",
    fill: "#F57859"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1138 8.66643L59.0022 21.6544L52.7048 21.9985L55.1138 8.66643Z",
    fill: "#F57859"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3147 33.9593L45.2573 42.0125L49.2932 27.263L55.3147 33.9593Z",
    fill: "#F04338"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5457 5.70977L52.0553 14.9792L50.7396 7.15783L56.5457 5.70977Z",
    fill: "#F04338"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1138 8.66643L52.7048 21.9985L52.0554 14.9792L55.1138 8.66643Z",
    fill: "#C52C23"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6727 0.904634L50.7396 7.15784L56.5457 5.70978L54.6727 0.904634Z",
    fill: "#EE3124"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7048 21.9985L49.2932 27.2629L55.3147 33.9592L52.7048 21.9985Z",
    fill: "#EE3124"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.596 9.92371L66.8194 2.96475L61.678 2.57492e-05L67.596 9.92371Z",
    fill: "#F04338"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1495 11.0505L56.5457 5.70978L61.678 3.71933e-05L62.0525 8.28663L62.1495 11.0505Z",
    fill: "#F04338"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0525 8.28662L67.596 9.92371L61.678 2.57492e-05L62.0525 8.28662Z",
    fill: "#FEF2D6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.857 19.2346L67.596 9.92368L62.0526 8.2866L68.857 19.2346Z",
    fill: "#F0DFAB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3636 25.6765L66.1982 14.9792L62.0526 8.28662L62.3636 25.6765Z",
    fill: "#CAA965"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.857 19.2346L62.3636 25.6765L66.1982 14.9792L68.857 19.2346Z",
    fill: "#282A45"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1117 5.73812C62.8228 6.02684 62.8228 6.49448 63.1117 6.78333C63.3998 7.07149 63.868 7.07149 64.1563 6.78333C64.4445 6.49448 64.4445 6.02684 64.1563 5.73812C63.868 5.44982 63.3998 5.44982 63.1117 5.73812Z",
    fill: "#282A45"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9056 22.1812H97.571V23.9845H84.882V32.5475H97.3276V34.3498H84.882V45.3053H82.9056V22.1812Z",
    fill: "#282A45"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M102.393 22.1812H104.369V43.5031H115.567V45.3053H102.393V22.1812Z",
    fill: "#282A45"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.064 37.8168H135.124L129.577 24.1229L124.064 37.8168ZM135.747 39.62H123.44L121.118 45.3053H118.899L128.363 22.1812H130.824L140.289 45.3053H138.07L135.747 39.62Z",
    fill: "#282A45"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M163.314 24.7815L154.889 45.3053H154.126L145.667 24.7815V45.3053H143.691V22.1812H146.638L154.507 41.3529L162.343 22.1812H165.324V45.3053H163.314V24.7815Z",
    fill: "#282A45"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M171.083 22.1812H173.06V45.3053H171.083V22.1812Z",
    fill: "#282A45"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M180.792 25.336V45.3053H178.816V22.1812H180.826L195.318 41.8735V22.1812H197.294V45.3053H195.353L180.792 25.336Z",
    fill: "#282A45"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M213.905 21.8003C217.719 21.8003 220.492 23.325 222.607 25.7521L221.117 26.8272C219.487 24.8853 216.852 23.6031 213.905 23.6031C208.462 23.6031 204.267 27.728 204.267 33.7605C204.267 39.7239 208.462 43.9538 213.905 43.9538C216.99 43.9538 219.417 42.428 220.701 41.1447V35.5979H211.963V33.8298H222.677V41.9081C220.631 44.1962 217.545 45.7559 213.905 45.7559C207.421 45.7559 202.187 40.9024 202.187 33.7605C202.187 26.6188 207.421 21.8003 213.905 21.8003Z",
    fill: "#282A45"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M238.767 23.6031C233.151 23.6031 229.614 27.867 229.614 33.7605C229.614 39.5853 233.151 43.9192 238.767 43.9192C244.313 43.9192 247.92 39.5853 247.92 33.7605C247.92 27.867 244.313 23.6031 238.767 23.6031ZM238.767 21.8003C245.528 21.8003 250 27.0002 250 33.7605C250 40.5209 245.528 45.7213 238.767 45.7213C231.971 45.7213 227.534 40.5209 227.534 33.7605C227.534 27.0002 231.971 21.8003 238.767 21.8003Z",
    fill: "#282A45"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9114 52.6351H86.3784V72.7081H96.8832V75.7591H82.9114V52.6351Z",
    fill: "#EE3124"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M100.699 52.6351H104.166V75.7591H100.699V52.6351Z",
    fill: "#EE3124"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.984 55.686H107.808V52.6351H125.593V55.686H118.451V75.7591H114.984V55.686Z",
    fill: "#EE3124"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M129.202 52.6351H144.734V55.686H132.669V62.4462H144.491V65.4977H132.669V72.7081H144.734V75.7591H129.202V52.6351Z",
    fill: "#EE3124"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M157.668 55.686H151.843V63.7983H157.668C160.164 63.7983 161.967 62.1698 161.967 59.7421C161.967 57.3156 160.164 55.686 157.668 55.686ZM156.177 66.8492H151.843V75.7591H148.377V52.6351H158.118C162.522 52.6351 165.538 55.4777 165.538 59.7421C165.538 63.9027 162.729 66.1215 159.783 66.5024L165.712 75.7591H161.69L156.177 66.8492Z",
    fill: "#EE3124"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M174.106 67.8896H183.431L178.751 55.6519L174.106 67.8896ZM184.436 70.9746H173.101L171.228 75.7591H167.414L176.601 52.6351H180.935L190.122 75.7591H186.309L184.436 70.9746Z",
    fill: "#EE3124"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M190.68 64.2143C190.68 57.1073 195.949 52.2541 202.536 52.2541C207.078 52.2541 209.921 54.4382 211.724 57.1419L208.777 58.7022C207.563 56.761 205.276 55.3391 202.536 55.3391C197.857 55.3391 194.251 59.0144 194.251 64.2143C194.251 69.3802 197.857 73.0895 202.536 73.0895C205.276 73.0895 207.563 71.6688 208.777 69.727L211.724 71.2868C209.886 73.9915 207.078 76.1757 202.536 76.1757C195.949 76.1757 190.68 71.3214 190.68 64.2143Z",
    fill: "#EE3124"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M221.921 66.087L212.872 52.6351H216.86L223.654 62.9668L230.381 52.6351H234.402L225.388 66.087V75.7591H221.921V66.087Z",
    fill: "#EE3124"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.aedad3a6016a0d479fa06b050dfde76f.svg";
export { ForwardRef as ReactComponent };